import { render, staticRenderFns } from "./invitationLetterIndex.vue?vue&type=template&id=66c9c642&scoped=true"
import script from "./invitationLetterIndex.vue?vue&type=script&lang=js"
export * from "./invitationLetterIndex.vue?vue&type=script&lang=js"
import style0 from "./invitationLetterIndex.vue?vue&type=style&index=0&id=66c9c642&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c9c642",
  null
  
)

export default component.exports